import React from 'react';
import { useLaunchHandler } from '../hooks/useLaunchHandler';

/** Registers Launch Handler queue consumer (must live under the app router). */
export const LaunchHandlerBridge: React.FC = () => {
  useLaunchHandler();
  return null;
};
